import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Storage_Keys, Session_Storage_keys } from 'src/app/services/storage/storage.keys';
import { StorageService } from 'src/app/services/storage/storage.service';
import { SessionStorageService } from '../services/storage/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  withoutAuthRoutes = [
    "/login",
    "/"
  ];

  catalogVersionRoutes = [
    "/admin/products",
    "/admin/take-off-catalog",
    "/admin/choices",
    "/admin/specifications",
    "/admin/additional-info",
    "/admin/special-conditions",
    "/admin/take-off-keys",
  ];

  takeOffCatalogRoute = [
    "/admin/take-off-catalog"
  ];

  houseInspectionRoute = [
    "/admin/house-inspections"
  ];

  PricingVersionRoutes = [
    "/admin/base-price-configurator",
    "/admin/specials-pricing-configurator",
    "/admin/additional-fees",
  ];

  regionByPackageRoute = [
    "/admin/region-configurator",
  ];

  asbestosRoute = [
    "/admin/asbestos-configurator",
  ]
  constructor(
    private router: Router,
    private storage: StorageService,
    private sessionStorage: SessionStorageService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const savedData = this.storage.getSavedData();
    if (this.withoutAuthRoutes.includes(state.url)) {
      if (savedData && savedData[Storage_Keys.authtoken]) {
        this.router.navigate(['/admin/gbb/versions']);
        return false;
      } else {
        this.manageVersionNavigation(state.url);
        return true;
      }
    } else {
      if (savedData && savedData[Storage_Keys.authtoken]) {
        this.manageVersionNavigation(state.url);
        return true;
      } else {
        this.router.navigate(['login']);
        return false;
      }
    }
  }

  manageVersionNavigation(url: string) {
    let catalogRoute = this.catalogVersionRoutes.find(x => x.includes(url));
    let pricingRoute = this.PricingVersionRoutes.find(x => x.includes(url));
    let takeOffRoute = this.takeOffCatalogRoute.find(x => x.includes(url));
    let houseInspection = this.houseInspectionRoute.find(x => x.includes(url));
    let regionbyPackage = this.regionByPackageRoute.find(x => x.includes(url));
    let asbestos = this.asbestosRoute.find(x => x.includes(url));
    let savedData = this.sessionStorage.getSavedData();
    if (catalogRoute || pricingRoute || takeOffRoute || houseInspection || regionbyPackage || asbestos) {
      if (savedData && !savedData[Session_Storage_keys.catalogVersion]) {
        alert('Please select any version to proceed.');
        this.router.navigate(['/admin/gbb/versions']);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

}
